import { registerPlugin } from '@capacitor/core';
const ContentsquareCAP = registerPlugin('ContentsquareCAP', {
    web: () => import('./web').then(m => new m.ContentsquareCAPWeb()),
});
// Use ContentsquarePlugin to simulate a proxy. Here we can add some logic on the Javascript side before calling native methods.
const ContentsquarePlugin = {
    optIn: function () {
        console.log('Opt in proxy');
        ContentsquareCAP.optIn();
    },
    optOut: function () {
        console.log('Opt out proxy');
        ContentsquareCAP.optOut();
    },
    sendTransaction(transactionItem) {
        console.log('sendTransaction proxy', transactionItem);
        return ContentsquareCAP.sendTransaction(transactionItem);
    },
    sendDynamicVar(dynamicVarItem) {
        console.log('sendDynamicVar proxy', dynamicVarItem);
        const dynVarValue = dynamicVarItem.dynVarValue;
        if (typeof dynVarValue === 'string') {
            return ContentsquareCAP.sendDynamicVarWithStringValue(dynamicVarItem);
        }
        else if (Number.isInteger(dynVarValue) && dynVarValue >= 0) {
            return ContentsquareCAP.sendDynamicVarWithIntValue(dynamicVarItem);
        }
        else {
            let callbackError = TypeError('The value of the DynamicVar should be either a string or an unsigned integer');
            return new Promise((_resolve, reject) => {
                reject(callbackError);
            });
        }
    },
    sendScreenName(screenName, cVarItems) {
        console.log('sendScreenName proxy', screenName);
        return ContentsquareCAP.sendScreenName({
            name: screenName,
            customVarItems: cVarItems,
        });
    },
    excludeURLForReplay(url) {
        return ContentsquareCAP.excludeURLForReplay({ url: url.toString() });
    },
    setPIISelectors(pii) {
        return ContentsquareCAP.setPIISelectors(pii);
    },
    setCapturedElementsSelector(elements) {
        return ContentsquareCAP.setCapturedElementsSelector({ elements });
    },
    collect(telemetryItem) {
        return ContentsquareCAP.collect(telemetryItem);
    }
};
document.addEventListener('DOMContentLoaded', function () {
    ContentsquareCAP.onReady();
});
export * from './definitions';
export { ContentsquarePlugin };
//# sourceMappingURL=index.js.map